import { useContext, useState } from 'react';
import {observer} from "mobx-react";
import {action} from "mobx";
import classNames from "classnames";
import styles from "./styles/Logo.module.scss";
import FontAwesome from "../utilities/FontAwesome";
import {StoreContext} from "../../stores/StoreLoader";
import imageCompression from "browser-image-compression";
import {useMachine} from "@xstate/react";
import {ImageUploadMachine} from "../machines/ImageUploadMachine";
import SchoolBlocksLoadingIndicator from "../utilities/SchoolBlocksLoadingIndicator";
import {isSchoolBlocksApp} from "../../utils/SchoolBlocksUtilities";

const Logo = observer((props) => {
    const [current, send] = useMachine(ImageUploadMachine);
    const {organizationStore, userStore} = useContext(StoreContext);

    const hideHeaderTitle = !!(organizationStore.organization.json_data?.settings?.appearance?.hideHeaderTitle && isSchoolBlocksApp());

    const [logo, setLogo] = useState(organizationStore.organization.logo);

    const orgLogoClassName = classNames({
        [styles.orgLogo]: true,
        [styles.orgLogoUpload]: userStore.isAdmin && !logo,
        [styles.orgLogoUploadLoading]: current.value !== 'IDLE' && current.value !== 'SUCCESS',
        [styles.orgLogoLarge]: hideHeaderTitle,
    });

    async function saveSettings(file, name) {
        send('UPLOAD');
        const logo = await organizationStore.imageUpload('logo', file, name);
        if (logo) {
            send('SUCCEED');
            action(() => organizationStore.organization.logo = logo.media_url)();
            setLogo(logo.media_url);
        } else {
            send("FAIL");
            setLogo(organizationStore.organization.logo);
        }

    }

    async function handleLogoChange(file) {
        // check for file because this can be triggered if user selects input but then cancels and no file is selected
        if (file) {
            send('PROCESS');
            try {
                if (['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
                    // compression library only supports these types
                    file = await imageCompression(file, {
                        maxSizeMB: 1,
                    });
                }
                if (file.size <= 1000000) {
                    await saveSettings(file, file.name);
                } else {
                    send('FAIL');
                }
            } catch (error) {
                send('FAIL');
                console.log('oops! ', error);
            }
        }
    }


    let logoBlock;
    if (logo && userStore.isAdmin && (current.value === 'IDLE' || current.value === 'SUCCESS')) {
        logoBlock = <>
            <label htmlFor={'logo-upload'}><img
                alt={`${organizationStore.organization.title} Logo`}
                src={logo}/></label>
            <input
                id={'logo-upload'}
                name={'logo-upload'}
                type={'file'}
                onChange={e => handleLogoChange(e.target.files[0])}
                accept={'image/*'}
            />
        </>
    } else if (logo && !userStore.isAdmin) {
        logoBlock = <img alt={`${organizationStore.organization.title} Logo`}
                         src={logo}/>;
    } else if (userStore.isAdmin) {
        let content;
        switch(current.value) {
            case 'IDLE':
                content = <div className={styles.uploadContainer}><FontAwesome prefix={'fas'} name={'fa-upload'} /> Upload Logo</div>;
                break;
            case 'FAILURE':
                content = <div className={styles.uploadContainer}><FontAwesome prefix={'fas'} ariaHidden={true} name={'fa-exclamation-triangle'}/> An error occurred!</div>;
                break;
            case 'PROCESSING':
                content = <div className={styles.uploadContainer}><SchoolBlocksLoadingIndicator background={'white'} /> Processing...</div>;
                break;
            case 'UPLOADING':
                content = <div className={styles.uploadContainer}><SchoolBlocksLoadingIndicator background={'white'} /> Uploading...</div>;
                break;
        }
        logoBlock = <>
            <label htmlFor={'logo-upload'} aria-label={'Add a Logo'}>
                {content}
            </label>
            <input
                id={'logo-upload'}
                name={'logo-upload'}
                type={'file'}
                onChange={e => handleLogoChange(e.target.files[0])}
                accept={'image/*'}
            />
        </>
    }

    return (
        <div className={orgLogoClassName}>
            {logoBlock}
        </div>
    );
});

export default Logo;
